import React, { Component } from 'react'
import Styled from 'styled-components'
import { ellipsis } from 'polished'

const Container = Styled.div`
  position: relative;
`

const Toggle = Styled.div`
  position: relative;
  ${ellipsis()}
  display: block;
  width: 100%;
  font-family: ${props => props.theme.fonts.regular};
  font-size: 1rem;
  line-height: 1.25;
  font-weight: normal;
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.text};
  border: 0;
  border-top: 1px solid transparent;
  border-bottom: 1px solid ${props => props.theme.colors.gray.shade100};
  padding: 0.5rem 1.5rem 0.5rem 0;
  transition: border 300ms;
  color: ${props => props.theme.colors.black};

  &:focus {
    outline: none;
    border-bottom-color: ${props => props.theme.colors.primary.shade400};
  }

  &:after {
    ${props => props.theme.mixins.icon};
    content: "arrow_drop_down";
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    color: ${props => props.theme.colors.black};
  }

  & + select:focus {
    border-bottom-color: ${props => props.theme.colors.primary.shade400};
  }
`

const Select = Styled.select`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
`

export default class extends Component {
  render() {
    const label = this.props.options
      .find(option => option.value === this.props.value)
      .label

    return (
      <Container>
        <Toggle>{label}</Toggle>

        <Select
          value={this.props.value}
          onChange={event => this.props.onChange(event.target.value)}
        >
          {this.props.options.map((option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          )))}
        </Select>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/editor/Select/index.js